import { ISingleIdParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetSubscriptionSubjectParams extends ISingleIdParams {
  subject: string;
}

export class SetSubscriptionSubjectRequest extends Request<ISetSubscriptionSubjectParams, IEmptyResult> {
  constructor(id: string, subject: string) {
    super('setSubscriptionSubject', {
      id: id,
      subject: subject
    });
  }
}
